<template>
  <div>
    <div v-if="dialogType == 'yellowType'">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        :modal="false"
        :wrapperClosable="false"
        class="yellowType"
      >
        <div>
          {{ $t(`authorization.organization.confirmDelete1`)
          }}<span class="yellow">{{
            $t(`authorization.organization.confirmDelete2`)
          }}</span
          ><span>!</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose(false)">{{
            $t(`common.cancel`)
          }}</el-button>
          <el-button type="primary" @click="handleClose(true)">{{
            $t(`common.confirm`)
          }}</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="dialogType == 'normalType'">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        :modal="false"
        :wrapperClosable="false"
        class="normalType"
      >
        <div v-if="eventType == 'addResourceGroup'">
          <div>{{ $t(`authorization.organization.selectResGroup`) }}</div>
          <Table
            :tableConfig="tableConfig"
            :tableData="tableData"
            @callBackAction="callBackAction"
            :api="api"
            :type="tableType"
          />
        </div>
        <div v-else-if="eventType == 'confirmEdit'">
          <div>{{ $t(`common.confirmEdit`) }}</div>
        </div>
        <div v-else>
          <el-form :model="addOrgForm" class="searchForm">
            <el-form-item
              :label="$t(`authorization.organization.selectAddorInput`)"
              v-if="addType == 'addChild'"
            >
              <el-radio v-model="addOrgForm.radio" label="1">{{
                $t(`authorization.organization.childOrg`)
              }}</el-radio>
              <el-radio v-model="addOrgForm.radio" label="2">{{
                $t(`authorization.organization.position`)
              }}</el-radio>
            </el-form-item>
            <el-form-item :label="$t(`authorization.organization.inputAddOrg`)">
              <el-input
                v-model="addOrgForm.inputName"
                :placeholder="$t(`authorization.organization.inputOrg`)"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose(false)">{{
            $t(`common.cancel`)
          }}</el-button>
          <el-button type="primary" @click="handleClose(true)">{{
            $t(`common.confirm`)
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Table from "@/components/table/index.vue";
export default {
  components: { Table },
  data() {
    return {
      selectedItems: [],
      api: {},
      tableType: "",
      addOrgForm: {},
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [{ type: "query", name: `common.query`, event: "query" }],
        },
        table: {
          selection: true,
          columns: [
            { prop: "name", label: `common.name` },
            { prop: "ID", label: `common.ID` },
            { prop: "email", label: `common.email` },
            { prop: "job", label: `common.position` },
            { prop: "status", label: `common.status` },
          ],
          action: {},
        },
      },
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: String,
      default: "",
    },
    dialogTitle: {
      type: String,
      default: "",
    },
    addType: {
      type: String,
      default: "",
    },
    addResourceGroup: {
      type: String,
      default: "",
    },
    eventType: {
      type: String,
      default: "",
    },
    tableData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    width: {
      type: String,
      default: "",
    },
  },
  methods: {
    callBackAction(param) {
      this[param.event](param);
    },
    handleSelectionChange(obj) {
      this.selectedItems = obj.selectedItems;
    },
    query() {
      this.$emit("queryResourceGroup");
    },
    handleClose(v) {
      this.$emit("setDialog", v, this.addOrgForm, this.selectedItems);
    },
  },
};
</script>
<style lang="less" scoped>
/* ::v-deep .el-dialog__header {
  background-color: #feaa09;
}
::v-deep .el-dialog__title {
  color: white;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
::v-deep .el-button:focus,
.el-button:hover {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
} */

::v-deep .el-dialog {
  width: 420px;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #343c6a;
  background: #343c6a;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #343c6a;
}
</style>
